// extracted by mini-css-extract-plugin
module.exports = {"lightbox-wrapper":"-jGJf","lightbox":"kCcIo","icon-close":"_1LJtn"};